export const form_logic = {
  "HyperLocal": {
    "prompt": "Collect estimated budgets for hyper-local offices, adjusting for district size, funding sources, and outside influence.",
    "seats": {
      // TOWNSHIP & VILLAGE
      "Town Council Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Town Councilor", "Township Board Member"]
      },
      "Township Trustee": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Village Trustee": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Village Council Member"]
      },
      "Alderman (Small Town)": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Town Alderman", "Village Alderman"]
      },

      // SCHOOL & EDUCATION
      "School Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Board of Education Member", "Education Board Trustee"]
      },
      "School Board President": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Community College Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },

      // SPECIAL DISTRICTS
      "Fire District Commissioner": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Water District Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Public Utility District (PUD) Board Member"]
      },
      "Irrigation District Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Electric Cooperative Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Flood Control District Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Levee District Commissioner": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Mosquito Control Board Member": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Transit District Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Regional Transit Authority Board"]
      },
      "Hospital District Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Hospital Authority Member"]
      },
      "Port Authority Commissioner": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "low",
        "synonyms": ["Port Commissioner"]
      },

      // MISC. HYPER-LOCAL
      "Planning Commission Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Zoning Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Zoning Board of Appeals Member"]
      },
      "Community Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Neighborhood Council Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Public Housing Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Housing Authority Board Member"]
      },
      "Library Board Trustee": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Library Board Member"]
      },
      "Park District Commissioner": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": ["Parks & Recreation Commissioner"]
      },
      "Cemetery Board Trustee": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Sanitation District Commissioner": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Air Quality Board Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Other Hyper-Local Office": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      }
    }
  },

  "CityGovernment": {
    "prompt": "Gather city-level campaign budgets, considering small vs. large metro areas.",
    "seats": {
      "Mayor": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "medium",
        "synonyms": ["City Mayor", "Town Mayor", "Municipal Mayor"]
      },
      "City Council Member": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": ["Councilman", "Councilwoman", "City Councilor"]
      },
      "City Commissioner": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Alderman (City)": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Municipal Judge": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "medium",
        "synonyms": ["Municipal Court Judge", "City Judge"]
      },
      "City Attorney (Elected)": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "medium",
        "synonyms": ["City Prosecutor", "City Solicitor"]
      },
      "City Clerk (Elected)": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "low",
        "synonyms": []
      },
      "City Treasurer (Elected)": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "City Auditor (Elected)": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "medium",
        "synonyms": []
      },
      // Some cities elect these, others appoint:
      "Police Chief (Elected)": {
        "required_fields": ["State", "County", "City/Town"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "City Constable": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Other City Office": {
        "required_fields": ["State", "County", "City/Town", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      }
    }
  },

  "CountyGovernment": {
    "prompt": "Collect estimated budgets for county offices, adjusting for county population size and competition.",
    "seats": {
      "County Commissioner": {
        "required_fields": ["State", "County", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "County Council Member": {
        "required_fields": ["State", "County", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": ["Councilman", "Councilwoman"]
      },
      "County Supervisor": {
        "required_fields": ["State", "County", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": ["Board of Supervisors Member"]
      },
      "County Executive": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "County Clerk (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "low",
        "synonyms": []
      },
      "County Treasurer (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "County Recorder (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "low",
        "synonyms": ["Register of Deeds"]
      },
      "County Assessor (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Sheriff": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Coroner/Medical Examiner (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "low",
        "synonyms": []
      },
      "District Attorney (County-Level)": {
        "required_fields": ["State", "County"],
        "competitiveness": "high",
        "synonyms": ["Prosecuting Attorney"]
      },
      "Public Defender (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "County Court Judge": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": ["County Judge"]
      },
      "Justice of the Peace": {
        "required_fields": ["State", "County", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Constable": {
        "required_fields": ["State", "County", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      "County Elections Supervisor (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "County Tax Collector (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "County Auditor (Elected)": {
        "required_fields": ["State", "County"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "County Soil & Water Conservation Board Member": {
        "required_fields": ["State", "County"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Port Commissioner (County-Level)": {
        "required_fields": ["State", "County"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Other County Office": {
        "required_fields": ["State", "County", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      }
    }
  },

  "StateGovernment": {
    "prompt": "Gather statewide and legislative campaign budgets, considering regional trends and population size.",
    "seats": {
      // STATEWIDE EXECUTIVES
      "Governor": {
        "required_fields": ["State"],
        "competitiveness": "high",
        "synonyms": []
      },
      "Lieutenant Governor": {
        "required_fields": ["State"],
        "competitiveness": "high",
        "synonyms": []
      },
      "Attorney General (State)": {
        "required_fields": ["State"],
        "competitiveness": "high",
        "synonyms": []
      },
      "Secretary of State": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "State Treasurer": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "State Auditor": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "State Comptroller": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Commissioner of Agriculture": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Commissioner of Insurance": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Commissioner of Labor": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Public Service Commissioner": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": ["Public Utilities Commissioner"]
      },
      "Railroad Commissioner": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      // LEGISLATIVE
      "State Senator": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": ["State Senate Representative"]
      },
      "State Representative": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": ["State House Member", "Assemblymember", "Assemblyman", "Assemblywoman"]
      },
      "State Assembly Member": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": []
      },
      // STATE JUDICIAL
      "State Supreme Court Justice": {
        "required_fields": ["State"],
        "competitiveness": "high",
        "synonyms": []
      },
      "State Court of Appeals Judge": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "State Superior Court Judge": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": ["District Court Judge" /* in some states */]
      },
      "State Circuit Court Judge": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Magistrate Judge (State)": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      },
      // EDUCATION
      "State Board of Education Member": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "State University Regent": {
        "required_fields": ["State"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Superintendent of Public Instruction": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": ["State School Superintendent"]
      },
      // OTHER
      "State Lands Commissioner": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "State Gaming Commissioner": {
        "required_fields": ["State"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Other State Office": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      }
    }
  },

  "FederalGovernment": {
    "prompt": "Federal campaign budgets, elected offices only.",
    "seats": {
      // don't need these 2 for now
      // "President of the United States": {
      //   "required_fields": [],
      //   "competitiveness": "high",
      //   "synonyms": []
      // },
      // "Vice President of the United States": {
      //   "required_fields": [],
      //   "competitiveness": "high",
      //   "synonyms": []
      // },
      "U.S. Senator": {
        "required_fields": ["State"],
        "competitiveness": "high",
        "synonyms": []
      },
      "U.S. Representative": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "high",
        "synonyms": ["Congressman", "Congresswoman"]
      },
      "U.S. House Delegate (DC, Territories)": {
        "required_fields": ["State", "District/Ward"],
        "competitiveness": "high",
        "synonyms": []
      }
    }
  },

  "TribalGovernment": {
    "prompt": "For tribes that hold elections for key offices, gather estimated campaign budgets.",
    "seats": {
      "Tribal Chairperson": {
        "required_fields": ["Tribe", "Reservation"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Tribal Vice Chairperson": {
        "required_fields": ["Tribe", "Reservation"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Tribal Council Member": {
        "required_fields": ["Tribe", "Reservation", "District/Ward"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Tribal Secretary (Elected)": {
        "required_fields": ["Tribe", "Reservation"],
        "competitiveness": "low",
        "synonyms": []
      },
      "Tribal Treasurer (Elected)": {
        "required_fields": ["Tribe", "Reservation"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Tribal Judge (Elected)": {
        "required_fields": ["Tribe", "Reservation"],
        "competitiveness": "medium",
        "synonyms": []
      },
      "Other Tribal Office": {
        "required_fields": ["Tribe", "Reservation", "District/Ward"],
        "competitiveness": "low",
        "synonyms": []
      }
    }
  }
};
